import "./css/Hero.css";
import logga from "../assets/logga.png";
import lore from "../content/lore";
import { useState } from "react";

function Hero() {

    return (
        <>
            <section className="hero">

                <div className="hero-image">
                </div>

                <div className = "lore" >
                    {lore}
                </div>
            </section>
        </>
    );
}

export default Hero;



 /*<div className="hero-top">
                    <img 
                    src={logga} 
                    alt="Gudfadderiet" 
                    className="logo" 
                    />
                </div>*/